export const GET_RESE_BMS_TABLE_DATA = {
    INIT: "GET_RESE_BMS_TABLE_DATA_INIT",
    SUCCESS: "GET_RESE_BMS_TABLE_DATA_SUCCESS",
    ERROR: "GET_RESE_BMS_TABLE_DATA_ERROR"
}

export const GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE = {
    INIT: "GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE_INIT",
    SUCCESS: "GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE_SUCCESS",
    ERROR: "GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE_ERROR"
}

export const GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE = {
    INIT: "GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE_INIT",
    SUCCESS: "GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE_SUCCESS",
    ERROR: "GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE_ERROR"
}

export const GET_RESE_BMS_TABLE_STATUS = {
    INIT: "GET_RESE_BMS_TABLE_STATUS_INIT",
    SUCCESS: "GET_RESE_BMS_TABLE_STATUS_SUCCESS",
    ERROR: "GET_RESE_BMS_TABLE_STATUS_ERROR"
}

export const UPDATE_RESE_BMS_TABLE_DATA = {
    INIT: "UPDATE_RESE_BMS_TABLE_DATA_INIT",
    SUCCESS: "UPDATE_RESE_BMS_TABLE_DATA_SUCCESS",
    ERROR: "UPDATE_RESE_BMS_TABLE_DATA_ERROR"
}